module.exports = __webpack_public_path__ + "static/media/folderDarkMode.b430c442.svg";